// src/mappers/sale/saleInvalidationMapper.ts
import { InvalidationPrefillDTO } from '../../types/sale/invalidation/InvalidationPrefillDTO';
import { SaleInvalidationDTO } from '../../types/sale/invalidation/SaleInvalidationDTO';
import { SelectedSaleDetailDTO } from '../../types/sale/invalidation/SelectedSaleDetailDTO';
import { SelectedSaleInfo } from '../../types/sale/invalidation/SelectedSaleInfo';

/** Form vacío coherente con el DTO actual */
export const getEmptySaleInvalidationForm = (): SaleInvalidationDTO => ({
  invalidationTypeCode: null,          // '1' | '2' | '3' | number
  comment: '',
  generationCodeToInvalidate: '',      // string (UUID)
  replacementGenerationCode: null,     // string (UUID) | null
});

/**
 * PREFILL -> FORM (merge con el estado actual si se pasa)
 * Ahora el prefill SOLO trae el generationCode.
 */
export const mapPrefillToForm = (
  prefill: InvalidationPrefillDTO,     // { generationCode: string }
  current?: SaleInvalidationDTO | null
): SaleInvalidationDTO => {
  const base = current ?? getEmptySaleInvalidationForm();

  return {
    ...base,
    generationCodeToInvalidate: prefill.generationCode ?? base.generationCodeToInvalidate,
  };
};

/** Detalle de backend -> info para mostrar en la tarjeta de resultado */
export const mapSelectedSaleDetailToInfo = (dto: SelectedSaleDetailDTO): SelectedSaleInfo => ({
  generationCode: dto.generationCode,
  controlNumber: dto.controlNumber,
  saleDate: dto.saleDate,
  documentTypeName: dto.documentTypeName,
  customerName: dto.customerName,
  total: dto.total,
});

/** (Opcional) Mapper del form -> payload que el backend espera */
export type SaleInvalidationCreatePayload = {
  generationCodeToInvalidate: string;
  replacementGenerationCode: string | null;
  invalidationTypeCode: number; // 1|2|3
  comment?: string | null;
};

export const toCreatePayload = (form: SaleInvalidationDTO): SaleInvalidationCreatePayload => ({
  generationCodeToInvalidate: form.generationCodeToInvalidate,
  replacementGenerationCode: form.replacementGenerationCode ?? null,
  invalidationTypeCode: form.invalidationTypeCode ? Number(form.invalidationTypeCode) : 0,
  comment: form.comment ?? null,
});
